// libs
import { createContext } from 'react';
import { INITIAL_CONTEXT } from './initial-context.constant';
import { ILocalStorageContext } from './context.interface';

export function createLocalStorageContext<Data = unknown>() {
  return createContext<ILocalStorageContext<Data>>(
    INITIAL_CONTEXT as ILocalStorageContext<Data>
  );
}

export default createLocalStorageContext;
